// Loads (and caches, keyed by URL) a glTF/GLB model - shared by every
// Avatar3DPicker instance so the same asset's three.js/GLTFLoader import and
// network fetch+parse only ever happen once per page load, however many
// times/components request it. Also lets main.js warm this up at boot,
// well before any picker actually mounts (see main.js's boot()).
const cache = new Map();

export function load_model(url){
    if(!cache.has(url)){
        cache.set(url, (async () => {
            const THREE = await import('three');
            const { GLTFLoader } = await import('three/examples/jsm/loaders/GLTFLoader.js');
            const gltf = await new Promise((resolve, reject) => {
                new GLTFLoader().load(url, resolve, undefined, reject);
            });
            return { THREE, gltf };
        })());
    }
    return cache.get(url);
}
